var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MutableList',{class:_vm.baseClass,attrs:{"items":_vm.items,"styles":{
    contentGap: '8px',
  },"separated":false,"removable":_vm.areManyItems,"sortable":_vm.isSortable,"data-test":"tooling-settings-list"},on:{"removeItem":_vm.onRemove,"moveItem":_vm.onMoveItem},scopedSlots:_vm._u([{key:"default",fn:function({ item, index }){return [_vm._t("default",null,{"item":item,"index":index})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }